import { combineReducers } from "redux";

import Mails from "@iso/redux/mail/reducer";
import Calendar from "@iso/redux/calendar/reducer";
import Box from "@iso/redux/box/reducer";
import Notes from "@iso/redux/notes/reducer";
import Todos from "@iso/redux/todos/reducer";
import Contacts from "@iso/redux/contacts/reducer";
import Cards from "@iso/redux/card/reducer";
import Chat from "@iso/redux/chat/reducers";
import DynamicChartComponent from "@iso/redux/dynamicEchart/reducer";
import Ecommerce from "@iso/redux/ecommerce/reducer";
import Invoices from "@iso/redux/invoice/reducer";
import YoutubeSearch from "@iso/redux/youtubeSearch/reducers";
import Articles from "@iso/redux/articles/reducers";
import Investors from "@iso/redux/investors/reducers";
import scrumBoard from "@iso/redux/scrumBoard/reducer";
import drawer from "@iso/redux/drawer/reducer";
import modal from "@iso/redux/modal/reducer";
import profile from "@iso/redux/profile/reducer";
import githubSearch from "@iso/redux/githubSearch/reducers";
import quiz from "@iso/redux/quiz/reducer";

import App from "@iso/redux/app/reducer";
import Auth from "@iso/redux/auth/reducer";
import Account from "@iso/redux/account/reducer";
import PasswordHistory from "@iso/redux/passwordHistory/reducer";
import AccountSetting from "@iso/redux/accountSetting/reducer";
import StoreAddEdit from "@iso/redux/storeAddEdit/reducer";
import ConfirmEmail from "@iso/redux/confirmEmail/reducer";
import ThemeSwitcher from "@iso/redux/themeSwitcher/reducer";
import LanguageSwitcher from "@iso/redux/languageSwitcher/reducer";
import ChainSetting from "@iso/redux/chainSetting/reducer";
import Store from "@iso/redux/store/reducer";
import Chain from "@iso/redux/chain/reducer";
import Task from "@iso/redux/task/reducer";
import SelectStore from "@iso/redux/selectStore/reducer";
import TaskAddEdit from "@iso/redux/taskAddEdit/reducer";
import Help from "@iso/redux/help/reducer";
import Notify from "@iso/redux/notify/reducer";
import Dashboard from "@iso/redux/dashboard/reducer";
import Upload from "@iso/redux/upload/reducer";
import GanttChart from "@iso/redux/ganttChart/reducer";
import OTA from "@iso/redux/ota/reducer";
import PlanAmount from "@iso/redux/planAmount/reducer";
import ContentAddEdit from "@iso/redux/content/reducer";
import ContentList from "@iso/redux/contentList/reducer";
import TaskCopyHistory from "@iso/redux/taskCopyHistory/reducer";
import taskStoresConfig from "@iso/redux/taskStoreConfig/reducer"
import CrawlPlanSale from "@iso/redux/crawlPlanSale/reducer";
import CrawlCoupon from "@iso/redux/crawlCoupon/reducer";
import CrawlSaleStatistic from "@iso/redux/crawlSaleStatistic/reducer";
import requestTime from "@iso/redux/requestTime/reducer";
import totalTimeWork from "@iso/redux/totalTimeWork/reducer";
import timesheet from "@iso/redux/timesheet/reducer";
import resourceSheet from "@iso/redux/resourceSheet/reducer";
import CrawlPrinceAchievement from "@iso/redux/crawlPrinceAchievement/reducer";
import CategoryTemplate from "@iso/redux/template/reducer";
import AutoCopyTask from "@iso/redux/autoCopyTask/reducer";
import CrawlingSetting from "@iso/redux/crawlingSetting/reducer";
import ReviewCrawlingSetting from "@iso/redux/reviewCrawlingSetting/reducer";
import TllBulkReservationSetting from "@iso/redux/tllBulkReservationSetting/reducer";
import RakutenScoringSetting from "@iso/redux/rakutenScoringSetting/reducer";
import SlackMeetingStoreMapping from "@iso/redux/slackMeetingStoreMapping/reducer";
import GalleryContent from "@iso/redux/galleryContent/reducer";
import ProposalSlideSetting from "@iso/redux/proposalSlideSetting/reducer";
import FacilityCredential from "@iso/redux/facilityCredential/reducer";
import ApiRoom from "@iso/redux/apiRoom/reducer";
import ApiPlan from "@iso/redux/apiPlan/reducer";
import SelectApiRoom from "@iso/redux/selectApiRoom/reducer";
import ApiImageCategory from "@iso/redux/apiImageCategory/reducer";
import ApiImage from "@iso/redux/apiImage/reducer";
import ApiOptionValues from "@iso/redux/apiOptionValues/reducer";
import ApiCrawlRoom from "@iso/redux/apiCrawlRoom/reducer";
import ApiCrawlPlan from "@iso/redux/apiCrawlPlan/reducer";
import ApiCancelPolicy from "@iso/redux/apiCancelPolicy/reducer";
import CrawlVisitorToHennaHotel from "@iso/redux/crawlVisitorToHennaHotel/reducer";
import TwoFactorAuthentication from "@iso/redux/twoFactorAuthentication/reducer";
import CrawlAdditionalRequest from "@iso/redux/crawlAdditionalRequest/reducer";
import ApiCrawlOption from "./apiCrawlOption/reducer";
import CrawlDataCollection from "./crawler/crawlDataCollection/reducer";
import CrawlRankingAndScore from "./crawler/crawlRankingAndScore/reducer";
import Team from "@iso/redux/team/reducer";
import TeamSettings from "@iso/redux/teamSettings/reducer";
import CrawlBookingPosition from "./crawler/crawlBookingPosition/reducer";
import CrawlDomesticIndicator from "./crawler/crawlDomesticIndicator/reducer";
import CrawlExtractSellingPrice from "@iso/redux/crawlExtractSellingPrice/reducer";
import Category from "@iso/redux/category/reducer";
import TaskStatus from "@iso/redux/taskStatus/reducer";
import AiCheckHistory from "@iso/redux/aiCheckHistory/reducer";

export default combineReducers({
  Auth,
  App,
  AccountSetting,
  Account,
  PasswordHistory,
  StoreAddEdit,
  ConfirmEmail,
  Chain,
  ThemeSwitcher,
  LanguageSwitcher,
  ChainSetting,
  Store,
  Task,
  SelectStore,
  TaskAddEdit,
  Help,
  Notify,
  Dashboard,
  Upload,
  GanttChart,
  OTA,
  PlanAmount,
  ContentAddEdit,
  ContentList,
  TaskCopyHistory,
  taskStoresConfig,
  CrawlPlanSale,
  CrawlCoupon,
  CrawlSaleStatistic,
  CrawlPrinceAchievement,
  CategoryTemplate,
  AutoCopyTask,
  CrawlingSetting,
  ReviewCrawlingSetting,
  TllBulkReservationSetting,
  RakutenScoringSetting,
  SlackMeetingStoreMapping,
  GalleryContent,
  ProposalSlideSetting,
  FacilityCredential,
  requestTime,
  totalTimeWork,
  timesheet,
  resourceSheet,
  ApiPlan,
  SelectApiRoom,
  ApiRoom,
  ApiImageCategory,
  ApiImage,
  ApiOptionValues,
  ApiCrawlRoom,
  ApiCrawlPlan,
  ApiCancelPolicy,
  CrawlVisitorToHennaHotel,
  TwoFactorAuthentication,
  CrawlAdditionalRequest,
  ApiCrawlOption,
  CrawlDataCollection,
  CrawlRankingAndScore,
  Team,
  TeamSettings,
  CrawlBookingPosition,
  CrawlDomesticIndicator,
  CrawlExtractSellingPrice,
  Category,
  TaskStatus,
  AiCheckHistory,

  //Sample
  Mails,
  Calendar,
  Box,
  Notes,
  Todos,
  Contacts,
  Cards,
  Chat,
  DynamicChartComponent,
  Ecommerce,
  Invoices,
  YoutubeSearch,
  Articles,
  Investors,
  scrumBoard,
  modal,
  drawer,
  profile,
  githubSearch,
  quiz,
});
